import * as React from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css';
import '../style/CopyrightNotice.css';

/**
 * Renders a copyright message of the form 'tenant icon © year tenant name',
 * linking to the home page of the tenant.
 *
 * Pure version of the component – only renders what you put in.
 *
 * @example
 * import {PureCopyrightNotice} from '@ta-interaktiv/react-copyright-notice';

 * class YourComponent extends React.Component {
 *   render() {
 *     return (
 *       <PureCopyrightNotice secondLevelDomainName='tagesanzeiger'
 *                            fullName='Tages-Anzeiger'
 *                            year={2017}/>
 *     )
 *   }
 * }
 *
 * @param {object} props
 * @param {boolean} [props.inverted=false] Use inverted (white-on-black) icon
 * @param {string} [props.name=Tages-Annzeiger] Tenant name
 * @param {string} [props.secondLevelDomainName=tagesanzeiger] Domain name,
 * used for
 * displaying the correct icon and linking to the home page
 * @param {number} [props.year=<current year>]
 */
export function PureCopyrightNotice(_ref) {
  var _ref$inverted = _ref.inverted,
      inverted = _ref$inverted === undefined ? false : _ref$inverted,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? 'Tages-Anzeiger' : _ref$name,
      _ref$secondLevelDomai = _ref.secondLevelDomainName,
      secondLevelDomainName = _ref$secondLevelDomai === undefined ? 'tagesanzeiger' : _ref$secondLevelDomai,
      _ref$year = _ref.year,
      year = _ref$year === undefined ? new Date(Date.now()).getFullYear() : _ref$year;

  return React.createElement(
    'a',
    {
      href: '//www.' + secondLevelDomainName + '.ch/',
      className: 'copyright-notice ' + (inverted ? 'inverted' : '')
    },
    ' ',
    React.createElement('img', {
      src: '//interaktiv.tagesanzeiger.ch/static/icons/' + secondLevelDomainName + (inverted ? '-inverted' : '') + '.svg',
      alt: '',
      className: 'ui mini middle aligned right spaced image'
    }),
    React.createElement(
      'small',
      null,
      '\xA9 ',
      year,
      ' ',
      name
    )
  );
}

export default PureCopyrightNotice;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-copyright-notice/es/pureCopyrightNotice.js
// module id = null
// module chunks = 